import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { CORE_CONFIGURATION } from '../configuration';
import { Store } from '@ngxs/store';
import { SessionState, SessionStateModel } from '../session';
import { buildAwsApi } from '../util.class';

@Injectable({
  providedIn: 'root',
  deps: [BaseApiService]
})
export class DashboardApiService {
  keyMapAWS: any;

  constructor(private http: BaseApiService, private store: Store, @Inject(CORE_CONFIGURATION) private config) {
    const { keyMapAWS }: SessionStateModel = this.store.selectSnapshot(SessionState);
    this.keyMapAWS = keyMapAWS;
  }

  getDashboardByPage(section: string) {
    const apiAWS = buildAwsApi(this.keyMapAWS, 'dashboard_by_page', { 'section': section });

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS,
      awsApi: apiAWS !== null
    });
  }
}
